import { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import Grid from "@mui/material/Grid";
import menujson from "../../Json/menu.json";
import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box } from "@mui/system";
import CBTFooter from "../../Components/CBTFooter";
import CBTHeader from "../../Components/CBTHeader";
import Card from "@mui/material/Card";
import { Typography, Button } from "@mui/material";
import { getAsset } from "../../Js/Common";
import { currentAssetSliceActions } from "../../Store/Slices/CurrentAssetSlice";
import { getFormatedDateTime } from "../../Js/TimeAndDate";
import HTMLFlipBook from "react-pageflip";
import "./style.css";
import IconButton from "@mui/material/IconButton";
import { getUserLog, updateLog, removeUploadedAudioOfBook } from "./Services";
import { userLogs, durationCalculate } from "../../Js/Common";

import SpatialAudioOffIcon from "@mui/icons-material/SpatialAudioOff";
import PauseCircleFilledIcon from "@mui/icons-material/PauseCircleFilled";

import spiral2 from "../../assets/spiral2.png";
import spiral1 from "../../assets/spiral1.png";
import spiral from "../../assets/spiral.png";
import bookmainback from "../../assets/book_mainback.png";

// import PauseOutlinedIcon from "@mui/icons-material/PauseOutlined";
// import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";

import BookImage from "./BookImage";
import BookReadAlong from "./BookReadAlong";
import BookText from "./BookText";
import BookLastPage from "./BookLastPage";
import BookModal from "./BookModal";

import RecordButton from "../../Components/Media/RecordButton";
import RatingModal from "../../Components/Modal/RatingModal";

let width = 1366;
let height = 768;

const Book = (props) => {
  const book = useRef();
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const { assignmentId, id } = useParams();
  let [bookwidth, setBookwidth] = useState(490);
  let [bookheight, setBookheight] = useState(476);
  let [spiralShow, setSpiralShow] = useState(true);
  let [assetData, setAssetData] = useState(null);
  let [pages, setPages] = useState([]);
  let [isPlay, setIsPlay] = useState(false);
  let [leftBtn, setLeftBtn] = useState(true);
  let [bookname, setBookname] = useState(null);
  let [fontsize, setFontsize] = useState("18px");
  let [currentpage, setCurrentpage] = useState(0);
  let [flipAudio, setFlipAudio] = useState(null);
  let [pagesLogs, setPagesLogs] = useState([]);
  let [updateLogFlag, setUpdateLogFlag] = useState(false);
  let [firstRender, setFirstRender] = useState(true);
  let [recordingPagesNumber, setRecordingPagesNumber] = useState(0);
  let [completedBookPages, setCompletedBookPages] = useState(0);
  let [bookIsNotComplete, setBookIsNotComplete] = useState(false);
  let [startTime, setStartTime] = useState(0);
  let [stateRefresh, setStateRefresh] = useState(false);
  let [leftRecord, setLeftRecord] = useState(false);
  let [rightRecord, setRightRecord] = useState(false);
  let [context, setContext] = useState(null);
  let [ratingVisible, setRatingVisible] = useState(false);
  let [defaultRatingLog, setDefaultRatingLog] = useState(null);

  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const { sessionUid, recordingContinueIndex, recordingAudioContinueIndex } =
    useSelector((state) => state.currentAsset);

  useEffect(() => {
    if (id) {
      getAssetData(id);
    }
  }, [id]);

  useEffect(() => {
    console.log("pages", pages);
    if (pages && pages.length > 0 && pagesLogs.length == 0) {
      let logsArr = new Array(pages.length).fill({
        visitedOn: [],
        recordedAudio: null,
      });
      setPagesLogs(logsArr);
    }
    if (pages && pages.length > 0) {
      let count = 0;
      for (let x = 0; x < pages.length; x++) {
        if (
          pages[x] &&
          pages[x]["controls"] &&
          pages[x]["controls"]["record"]
        ) {
          count++;
        }
      }
      setRecordingPagesNumber(count);
    }
  }, [pages]);

  useEffect(() => {
    console.log("context", context);
  }, [context]);

  useEffect(() => {
    setFirstRender(false);
    const innerFun = async () => {
      let log = await getUserLog({
        verb: "readBook",
        target: assignmentId,
        actor: userInfo.uid,
        site_uuid: userInfo.site_uuid,
      });
      let assets = sessionStorage.getItem("assignmentAssets");
      if (assets) {
        assets = JSON.parse(assets)[0];
        setContext({
          taskID: assets["taskID"],
          assetId: assets["id"],
        });
      }
      if (
        log &&
        log.data &&
        log.data.data.length > 0 &&
        userInfo.rolesInfo.title.toLowerCase() == "learner"
      ) {
        log.data.data[0]["outcome"]["pagesRecord"].push({
          visitedOn: [],
          recordedAudio: null,
        });
        log.data.data[0]["outcome"]["pagesRecord"].unshift({
          visitedOn: [],
          recordedAudio: null,
        });
        setPagesLogs(log.data.data[0]["outcome"]["pagesRecord"]);
        setUpdateLogFlag(true);
      }
    };
    innerFun();
  }, []);

  useEffect(() => {
    let audio = new Audio(require("../../assets/audio/page-flip.mp3"));
    setFlipAudio(audio);

    const { innerWidth: wwidth, innerHeight: wheight } = window;
    resizeBook(wheight, wwidth);
    window.onresize = (e) => {
      resizeBook(e.target.innerHeight, e.target.innerWidth);
    };

    dispatch(currentAssetSliceActions.setDurationFlag(false));
    setStartTime(Date.now());
    return () => {
      sessionStorage.removeItem("assignmentAssets");
    };
  }, []);

  // To drop logs
  const logFunction = async (duration) => {
    let logObj = {
      actor: userInfo.uid,
      verb: null,
      outcome: {
        attempts: 1,
        duration: duration,
        assetType: {
          group: "practice",
          value: "BOOK",
        },
        userAnswer: [],
        isEvaluated: "complete",
        actualAnswer: [],
        genericScore: 1,
      },
      site_uuid: userInfo.site_uuid,
      target: null,
      context: context,
      session_uid: null,
    };

    let newPageLogs = [...pagesLogs];
    newPageLogs.pop();
    newPageLogs.shift();

    if (userInfo.rolesInfo.title.toLowerCase() == "learner") {
      logObj["verb"] = "attemptAssignment";
      logObj["session_uid"] = sessionUid;
      logObj["outcome"]["isEvaluated"] = "complete";
      logObj["outcome"]["userAnswer"] = [
        {
          ans: newPageLogs,
          score: 1,
          duration: duration,
        },
      ];
      logObj["target"] = assignmentId;
    } else {
      logObj["verb"] = "courseView";
    }
    console.log("logObj", logObj);
    let logResponse = await userLogs(logObj);
    if (userInfo.rolesInfo.title.toLowerCase() !== "learner") {
      navigation(-1);
    }
  };

  let updateLogFun = async (data) => {
    let logResponse;
    let newPageLogs = [...data];
    newPageLogs.pop();
    newPageLogs.shift();
    console.warn("HEREEEE", updateLogFlag);
    if (updateLogFlag) {
      logResponse = await updateLog(
        { outcome: { pagesRecord: newPageLogs } },
        {
          verb: "readBook",
          target: assignmentId,
          actor: userInfo.uid,
          site_uuid: userInfo.site_uuid,
        }
      );
    } else {
      logResponse = await userLogs({
        actor: userInfo.uid,
        verb: "readBook",
        outcome: { pagesRecord: newPageLogs },
        site_uuid: userInfo.site_uuid,
        target: assignmentId,
        context: { assetId: id },
        session_uid: null,
      });
      setUpdateLogFlag(true);
    }
  };

  const resizeBook = (innerHeight, innerWidth) => {
    let widthDiff, heightDiff;
    console.log("::::innerHeight", innerHeight);
    console.log("::::height", height);
    setBookheight(innerHeight * 0.62);
    // if (innerHeight > height) {
    //   console.log("::::Helloif");
    //   heightDiff = innerHeight - height;
    //   let percntDiff = process.env.REACT_APP_FOR_IPAD ? ((heightDiff * 100) / innerHeight).toFixed(2) : ((heightDiff * 100) / innerHeight).toFixed(2);
    //   console.log("percntDiff", percntDiff);
    //   let diffaddremove = ((percntDiff * bookheight) / 100).toFixed(2);
    //   console.log("diffaddremove", diffaddremove);
    //   let newHeight = bookheight + Math.round(+diffaddremove);
    //   setBookheight(newHeight);
    // }
    // if (innerHeight < height) {
    //   console.log("::::Helloelse");
    //   heightDiff = height - innerHeight - 100;
    //   let percntDiff = ((heightDiff * 100) / height).toFixed(2);
    //   console.log("percntDiff", percntDiff);
    //   let diffaddremove = ((percntDiff * bookheight) / 100).toFixed(2);
    //   let newHeight = bookheight - Math.round(+diffaddremove);
    //   setBookheight(newHeight);
    // }

    if (innerWidth > width) {
      widthDiff = innerWidth - width;
      let percntDiff = ((widthDiff * 100) / innerWidth).toFixed(2);
      console.log("percntDiff", percntDiff);
      let diffaddremove = ((percntDiff * bookwidth) / 100).toFixed(2);
      let newWidth = bookwidth + Math.round(+diffaddremove);
      setBookwidth(newWidth);
    }
    if (innerWidth < width) {
      widthDiff = width - innerWidth;
      let percntDiff = ((widthDiff * 100) / width).toFixed(2);
      console.log("percntDiff", percntDiff);
      let diffaddremove = ((percntDiff * bookwidth) / 100).toFixed(2);
      let newWidth = bookwidth - Math.round(+diffaddremove);
      setBookwidth(newWidth);
    }
  };

  let getAssetData = async (assetId) => {
    if (assetId) {
      let assetData = await getAsset(assetId);
      setAssetData(assetData.data[0]);
      let pagesArr =
        assetData.data[0].content.content.epage.options.content[0].book.pages;
      pagesArr.unshift({
        id: "page_" + Date.now(),
        page: [
          {
            image:
              assetData.data[0].content.content.epage.options.content[0].book
                .coverimg,
            attribute: "center width-none height-none align-none",
          },
        ],
      });
      pagesArr.push({
        id: "page_" + Date.now(),
        page: [
          {
            last_page: true,
            attribute: "",
          },
        ],
      });
      setPages(pagesArr);
      setBookname(
        assetData.data[0].content.content.epage.options.content[0].book.name
      );
      let fontSize =
        assetData.data[0].content.content.epage.options.content[0].book.fontsize.split(
          ":"
        );
      fontSize = fontSize[1].split(";");
      setFontsize(fontSize[0]);
      //setCoverImage(assetData.data[0].content.content.epage.options.content[0].book.coverimg);
      dispatch(currentAssetSliceActions.setAssetData(assetData.data[0]));
    }
  };

  const updateLogArray = async (name, index) => {
    let newArr = [...pagesLogs];
    let obj = { ...newArr[index] };
    if (obj["recordedAudio"]) {
      let removeFiles = await removeUploadedAudioOfBook([obj["recordedAudio"]]);
    }
    obj["visitedOn"] = [...obj["visitedOn"], getFormatedDateTime(Date())];
    obj["recordedAudio"] = name;
    newArr.splice(index, 1, obj);
    setPagesLogs(newArr);
    updateLogFun(newArr);
  };

  const renderComponent = (obj, index, totalLength) => {
    if (obj.hasOwnProperty("image")) {
      return <BookImage data={obj} totalPageObjs={totalLength}></BookImage>;
    }
    if (obj.hasOwnProperty("read_along") && obj.read_along) {
      return (
        <BookReadAlong
          data={obj}
          index={index}
          fontSize={fontsize}
          isplay={isPlay}
          currentpage={currentpage}
          left={leftBtn}
          togglePlay={(flg) => {
            setIsPlay(flg);
          }}
        ></BookReadAlong>
      );
    }
    if (obj.hasOwnProperty("text")) {
      return <BookText data={obj} fontSize={fontsize}></BookText>;
    }
    if (obj.hasOwnProperty("last_page") && obj.last_page) {
      return <BookLastPage></BookLastPage>;
    }
  };

  const submitBook = () => {
    let recordedPages = 0;
    if (userInfo.rolesInfo.title.toLowerCase() == "learner") {
      for (let x = 0; x < pagesLogs.length; x++) {
        if (pagesLogs[x]["recordedAudio"]) {
          recordedPages++;
        }
      }
      console.log("123", recordingPagesNumber);
      console.log("123", recordedPages);
      console.log("123", (+recordedPages / +recordingPagesNumber) * 100);
      setCompletedBookPages(recordedPages);
      if (+recordedPages / +recordingPagesNumber != 1) {
        setBookIsNotComplete(true);
      } else {
        logFunction(durationCalculate(0, startTime));
        setRatingVisible(true);
        dropDefaultRating(1);
        setStartTime(0);
      }
    } else {
      logFunction(durationCalculate(0, startTime));
      setStartTime(0);
    }
  };

  const dropDefaultRating = async (ratingValue) => {
    let logObj = {
      actor: userInfo.uid,
      verb: "ratingAssignment",
      outcome: { session_uid: sessionUid, learnerRating: ratingValue },
      site_uuid: userInfo.site_uuid,
      target: assignmentId,
      context: null,
      session_uid: null,
    };
    let logResponse = await userLogs(logObj);
    if (logResponse && logResponse.data) {
      setDefaultRatingLog(logResponse.data);
    }
  };

  let ratingDone = async (rating) => {
    if (defaultRatingLog && defaultRatingLog.uid) {
      let logResponse = await updateLog(
        { outcome: { session_uid: sessionUid, learnerRating: rating } },
        {
          uid: defaultRatingLog.uid,
          site_uuid: userInfo.site_uuid,
        }
      );
      if (logResponse) {
        setRatingVisible(true);
        navigation(-1);
      }
    }
  };

  return (
    <Grid
      container
      sx={{
        flexDirection: "row",
        justifyContent: "flex-start",
        overflow: "hidden",
      }}
    >
      <Grid item xs={12} sx={{}}>
        <Box
          sx={{
            height: "65.6vh",
            mt: 1,
            mx: 4.1,
            borderRadius: 5,
            // boxShadow: '0px 5px 10px 5px #aaa',
            // backgroundImage: `url(${bookmainback})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "100%",
            "@media (min-width: 1636px)": {
              height: "74vh",
            },
          }}
        >
          <Grid
            container
            sx={{
              flexDirection: "row",
              flexFlow: "wrap",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
              marginTop: "2px",
            }}
          >
            <HTMLFlipBook
              width={bookwidth}
              height={bookheight}
              showCover={true}
              ref={book}
              disableFlipByClick={true}
              onFlip={(e) => {
                setCurrentpage(e.data);
                setIsPlay(false);
                setRightRecord(false);
                setLeftRecord(false);
                // if (
                //   leftRecord ||
                //   rightRecord ||
                //   recordingAudioContinueIndex != -1 ||
                //   recordingContinueIndex != -1
                // ) {
                //   setStateRefresh(true);
                //   setTimeout(() => {
                //     setStateRefresh(false);
                //   }, 500);
                // }
              }}
              onChangeState={(e) => {
                if (e.data == "user_fold" || e.data == "flipping") {
                  setSpiralShow(false);
                  flipAudio.play();
                }
                if (e.data == "read") {
                  setSpiralShow(true);
                }
              }}
              size="stretch"
            >
              {pages &&
                pages.map((val, index) => {
                  return (
                    <Grid
                      item
                      xs={6}
                      sx={{
                        borderRadius: index % 2 != 0 ? 0 : 5,
                        boxShadow: "0px 5px 10px 5px #aaa",
                        borderRadius: 5,
                      }}
                    >
                      <Card
                        sx={
                          index % 2 != 0
                            ? val.background
                              ? {
                                  boxShadow:
                                    "inset 20px 0px 15px 0px rgba(114,114,114,0.4)",
                                  backgroundColor: "#FCFCFC",
                                  height: "65.6vh",
                                  maxHeight: "65.6vh",
                                  borderRight: 1,
                                  borderRightColor: "rgba(242,242,242,0.36)",
                                  borderTopLeftRadius: 20,
                                  borderBottomLeftRadius: 20,
                                  marginLeft: "2px",
                                  backgroundSize: "cover",
                                  backgroundRepeat: "no-repeat",
                                  overflow: process.env.REACT_APP_FOR_IPAD == 'true' ? "auto": "hidden",
                                  backgroundImage: `url(${sessionStorage.getItem(
                                    "media_url"
                                  )}image/${val.background})`,
                                  "@media (min-width: 1636px)": {
                                    height: "70.4vh",
                                  },
                                }
                              : {
                                  boxShadow:
                                    "inset 20px 0px 15px 0px rgba(114,114,114,0.4)",
                                  borderRight: 1,
                                  borderRightColor: "rgba(242,242,242,0.36)",
                                  backgroundColor: "#FCFCFC",
                                  height: "65.6vh",
                                  maxHeight: "65.6vh",
                                  borderTopLeftRadius: 20,
                                  borderBottomLeftRadius: 20,
                                  overflow: process.env.REACT_APP_FOR_IPAD == 'true' ? "auto": "hidden",
                                  marginLeft: "2px",
                                  "@media (min-width: 1636px)": {
                                    height: "70.4vh",
                                  },
                                }
                            : val.background
                            ? {
                                boxShadow:
                                  "inset 20px 0px 15px 0px rgba(114,114,114,0.4)",
                                backgroundColor: "#FCFCFC",
                                height: "65.6vh",
                                maxHeight: "65.6vh",
                                borderTopRightRadius: 20,
                                borderBottomRightRadius: 20,
                                marginRight: "2px",
                                backgroundSize: "cover",
                                backgroundRepeat: "no-repeat",
                                overflow: process.env.REACT_APP_FOR_IPAD == 'true' ? "auto": "hidden",
                                backgroundImage: `url(${sessionStorage.getItem(
                                  "media_url"
                                )}image/${val.background})`,
                                "@media (min-width: 1636px)": {
                                  height: "70.4vh",
                                },
                              }
                            : {
                                boxShadow:
                                  "inset 20px 0px 15px 0px rgba(114,114,114,0.4)",
                                backgroundColor: "#FCFCFC",
                                height: "65.6vh",
                                maxHeight: "65.6vh",
                                borderTopRightRadius: 20,
                                borderBottomRightRadius: 20,
                                marginRight: "2px",
                                overflow: process.env.REACT_APP_FOR_IPAD == 'true' ? "auto": "hidden",
                                "@media (min-width: 1636px)": {
                                  height: "70.4vh",
                                },
                              }
                        }
                      >
                        {val &&
                          val.page &&
                          val.page.map((page, index1) => {
                            return (
                              <>
                                {renderComponent(page, index, val.page.length)}
                              </>
                            );
                          })}
                      </Card>
                    </Grid>
                  );
                })}
            </HTMLFlipBook>
            {spiralShow && (
              <Box
                position={"absolute"}
                sx={{
                  backgroundImage:
                    currentpage + 1 == 1
                      ? `url(${spiral2})`
                      : currentpage + 1 == pages.length
                      ? `url(${spiral1})`
                      : `url(${spiral})`,
                  backgroundRepeat: "repeat-y",
                  height: "65.5vh",
                  width: "3.5%",
                  zIndex: 1,
                  top: "0rem",
                  "@media (min-width: 1636px)": {
                    left: "49%",
                    height: "69.6vh",
                  },
                }}
              ></Box>
            )}
          </Grid>
        </Box>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          height: "8.4vh",
          mx: 5,
          backgroundColor: "#F5F7FF",
          borderRadius: 10,
          px: 2,
          mt: 2,
        }}
      >
        <Grid item>
          {pages && pages.length > 0 && (
            <>
              {currentpage != 0 && (
                <IconButton
                  sx={{
                    borderRadius: 50,
                    borderColor: "#CCC",
                    mx: 1,
                    bgcolor: "#FFF",
                    boxShadow: 2,
                  }}
                >
                  <span
                    style={{
                      paddingLeft: 4,
                      paddingRight: 4,
                      fontSize: "1.05rem",
                      fontWeight: 600,
                      color: "#DB8829",
                    }}
                  >
                    {currentpage} of {pages.length - 1}
                  </span>
                </IconButton>
              )}
              {currentpage != 0 &&
                pages[currentpage] &&
                pages[currentpage]["controls"] &&
                pages[currentpage]["controls"]["read_along"] && (
                  <IconButton
                    size="small"
                    sx={{
                      backgroundColor: "#FFFFFF",
                      boxShadow: 2,
                      color: "primary.main",
                     
                    }}
                    onClick={() => {
                      setLeftBtn(true);
                      if (isPlay) {
                        setIsPlay(false);
                      } else {
                        setIsPlay(true);
                      }
                    }}
                    disabled={
                      leftRecord ||
                      rightRecord ||
                      recordingAudioContinueIndex != -1 ||
                      recordingContinueIndex != -1 ||
                      (isPlay && !leftBtn)
                    }
                  >
                    {isPlay && leftBtn ? (
                      <PauseCircleFilledIcon
                        sx={{
                          "@media (min-width: 1636px)": { fontSize: "2rem" },
                        }}
                      />
                    ) : (
                      <SpatialAudioOffIcon
                        sx={{
                          "@media (min-width: 1636px)": { fontSize: "2rem" },
                        }}
                      />
                    )}
                  </IconButton>
                )}
              {currentpage != 0 &&
                pages[currentpage] &&
                pages[currentpage]["controls"] &&
                pages[currentpage]["controls"]["record"] && (
                  <RecordButton
                    size="small"
                    checkOnPause={false}
                    resetComponent={stateRefresh}
                    alreadyRecorded={
                      pagesLogs.length > 0 &&
                      pagesLogs[currentpage] &&
                      pagesLogs[currentpage]["recordedAudio"]
                        ? `${
                            sessionStorage.getItem("site_ip")
                              ? `${sessionStorage.getItem("site_ip")}:${
                                  sessionStorage
                                    .getItem("port_data")
                                    .split(",")[0]
                                }`
                              : process.env.REACT_APP_SERVER_API
                          }/media/userUploadedData/${
                            pagesLogs[currentpage]["recordedAudio"]
                          }`
                        : null
                    }
                    startRecord={(flag) => {
                      console.log("******flag", flag);
                      setLeftRecord(flag);
                    }}
                    uploadedAudioName={(audioName) => {
                      updateLogArray(audioName, currentpage);
                    }}
                    uploadOnPause={true}
                    deleteOldAudio={
                      userInfo.rolesInfo.title.toLowerCase() == "learner"
                    }
                    disabled={
                      rightRecord ||
                      recordingAudioContinueIndex != -1 ||
                      recordingContinueIndex == 2 ||
                      isPlay
                    }
                    audioDisable={
                      rightRecord ||
                      recordingContinueIndex != -1 ||
                      recordingAudioContinueIndex == 2 ||
                      isPlay
                    }
                    index={1}
                  ></RecordButton>
                )}
            </>
          )}
        </Grid>
        <Grid item sx={{ display: "flex" }}>
          {pages && pages.length > 0 && (
            <>
              {currentpage != 0 &&
                pages[currentpage + 1] &&
                pages[currentpage + 1]["controls"] &&
                pages[currentpage + 1]["controls"]["read_along"] && (
                  <IconButton
                    size="small"
                    sx={{
                      backgroundColor: "#FFFFFF",
                      boxShadow: 2,
                      color: "primary.main",
                     
                    }}
                    onClick={() => {
                      setLeftBtn(false);
                      if (isPlay) {
                        setIsPlay(false);
                      } else {
                        setIsPlay(true);
                      }
                    }}
                    disabled={
                      leftRecord ||
                      rightRecord ||
                      recordingAudioContinueIndex != -1 ||
                      recordingContinueIndex != -1 ||
                      (isPlay && leftBtn)
                    }
                  >
                    {isPlay && !leftBtn ? (
                      <PauseCircleFilledIcon
                        sx={{
                          "@media (min-width: 1636px)": { fontSize: "2rem" },
                        }}
                      />
                    ) : (
                      <SpatialAudioOffIcon
                        sx={{
                          "@media (min-width: 1636px)": { fontSize: "2rem" },
                        }}
                      />
                    )}
                  </IconButton>
                )}
              {currentpage != 0 &&
                pages[currentpage + 1] &&
                pages[currentpage + 1]["controls"] &&
                pages[currentpage + 1]["controls"]["record"] && (
                  <RecordButton
                    size="small"
                    checkOnPause={false}
                    resetComponent={stateRefresh}
                    alreadyRecorded={
                      pagesLogs.length > 0 &&
                      pagesLogs[currentpage + 1] &&
                      pagesLogs[currentpage + 1]["recordedAudio"]
                        ? `${
                            sessionStorage.getItem("site_ip")
                              ? `${sessionStorage.getItem("site_ip")}:${
                                  sessionStorage
                                    .getItem("port_data")
                                    .split(",")[0]
                                }`
                              : process.env.REACT_APP_SERVER_API
                          }/media/userUploadedData/${
                            pagesLogs[currentpage + 1]["recordedAudio"]
                          }`
                        : null
                    }
                    startRecord={(flag) => {
                      setRightRecord(flag);
                    }}
                    uploadedAudioName={(audioName) => {
                      updateLogArray(audioName, currentpage + 1);
                    }}
                    uploadOnPause={true}
                    deleteOldAudio={
                      userInfo.rolesInfo.title.toLowerCase() == "learner"
                    }
                    disabled={
                      leftRecord ||
                      recordingAudioContinueIndex != -1 ||
                      recordingContinueIndex == 1 ||
                      isPlay
                    }
                    audioDisable={
                      leftRecord ||
                      recordingContinueIndex != -1 ||
                      recordingAudioContinueIndex == 1 ||
                      isPlay
                    }
                    index={2}
                  ></RecordButton>
                )}
              {currentpage != 0 && pages[currentpage + 1] && (
                <IconButton
                  sx={{
                    borderRadius: 50,
                    borderColor: "#CCC",
                    bgcolor: "#FFF",
                    boxShadow: 2,
                  }}
                >
                  <span
                    style={{
                      paddingLeft: 5,
                      paddingRight: 5,
                      fontSize: "1.05rem",
                      fontWeight: 600,
                      color: "#DB8829",
                    }}
                  >
                    {currentpage + 1} of {pages.length - 1}
                  </span>
                </IconButton>
              )}
            </>
          )}
        </Grid>
      </Grid>
      <Grid item xs={12} sx={{ mt: 1 }}>
        <Grid
          container
          sx={{
            flexDirection: "row",
            justifyContent: "space-between",
            flexWrap: "nowrap",
            alignItems: "center",
            px: 6,
          }}
        >
          <Grid item sx={{}}></Grid>
          <Grid item>
            <Grid
              container
              sx={{ gap: 2, alignItems: "center", paddingTop: 0.8 }}
            >
              <Grid item>
                <Box sx={{ borderRadius: 10 }}>
                  <Button
                    sx={{
                      width: "10vw",
                      textTransform: "inherit",
                      borderRadius: 10,
                      boxShadow: 3,
                      mb: 2,
                      fontWeight: "600",
                      fontSize: "1rem",
                      "@media (min-width: 1636px)": { fontSize: "1.4rem" },
                    }}
                    onClick={submitBook}
                  >
                    Submit
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <BookModal
        visible={bookIsNotComplete}
        primaryText={`${completedBookPages}/${recordingPagesNumber} pages completed.`}
        alert={true}
        toggleModal={(flag) => setBookIsNotComplete(flag)}
        timeout={3000}
        progressVal={(+completedBookPages / +recordingPagesNumber) * 100}
      ></BookModal>
      <RatingModal
        visible={ratingVisible}
        toggleModal={(flag) => setRatingVisible(flag)}
        done={(rating) => {
          ratingDone(rating);
        }}
      ></RatingModal>
    </Grid>
  );
};
const useStyles = makeStyles({
  ListItemText: {
    fontSize: "1rem !important",
  },
  spiral: {
    backgroundImage: `url(${spiral})`,
    backgroundSize: "cover",
    height: "100%",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default Book;
